import { subDays, addDays } from "date-fns";

const CRMBannerConfigs = {
  master: {
    title: "CRM Banner",
    apiName: "crm/crmbanner",
    orderBy: "id",
    orderMethod: "ASC",
    additionalParams: { 
      // add_params
    },
  },
  dialog: {
    title: "CRM Banner",
    isForm: false,
  },

  columns: [
    // add_configs
    {
      name: "Name",
      field: "name",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
      object_name: "",
      object_field: "",
    },
    {
      name: "Image",
      field: "image",
      default_value: null,
      type: "zirvu_file_manager",
      table: true,
      editor: true,
    },
  ],
};

export default CRMBannerConfigs;
